export default __webpack_public_path__ + "static/media/roadmap-2.2e23cad2.svg";